import { NgModule } from '@angular/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { HasAnyAuthorityDirective } from '../core/directives/auth/has-any-authority.directive';
import { AutocompleteOffDirective } from '../core/directives/autocomplete-off/autocomplete-off.directive';
import { BtnDarkClassDirective } from '../core/directives/btn-dark-class/btn-dark-class.directive';
import { DelayRenderingDirective } from '../core/directives/delay/delay-rendering.directive';
import { DelayShowingDirective } from '../core/directives/delay/delay-showing.directive';
import { ParentValidatorDirective } from '../core/directives/parent-validator/parent-validator.directive';
import { PriorityClassDirective } from '../core/directives/priority-class/priority-class.directive';
import { ScheduledClassDirective } from '../core/directives/scheduled-class/scheduled-class.directive';
import { StatusClassDirective } from '../core/directives/status-class/status-class.directive';
import { VisibilityByDeviceDirective } from '../core/directives/visibility-by-device/visibility-by-device.directive';
import { ClassByAuthorityDirective } from '../core/directives/visiblity-by-authority/class-by-authority.directive';
import { SchoolYearDisabledActionDirective } from '../core/directives/school-year-disabled-action/school-year-disabled-action.directive';
import { FeatureFlagHiddenDirective } from '../core/directives/feature-flag-hidden/feature-flag-hidden.directive';
import { TooltipDirective } from '../core/directives/tooltip/tooltip.directive';
import { NgSelectA11yDirective } from '../core/directives/ng-select-a11y/ng-select-a11y.directive';
import { TablistA11yDirective } from '../core/directives/tablist-a11y/tablist-a11y.directive';
import { AccordionA11yDirective } from '../core/directives/accordion-a11y/accordion-a11y.directive';
import { CollapseInertA11yDirective } from '../core/directives/collapse-inert-a11y/collapse-inert-a11y.directive';
import { DropdownToggleHaspopupA11yDirective } from '../core/directives/dropdown-toggle-haspopup-a11y/dropdown-toggle-haspopup-a11y.directive';
import { TimepickerMeridianA11yDirective } from '../core/directives/timepicker-meridian-a11y/timepicker-meridian-a11y.directive';
import { BsDatepickerKeyboardA11yDirective } from '../core/directives/bs-datepicker-keyboard-a11y/bs-datepicker-keyboard-a11y.directive';

@NgModule({
  imports: [BsDatepickerModule],
  declarations: [
    HasAnyAuthorityDirective,
    DelayRenderingDirective,
    DelayShowingDirective,
    AutocompleteOffDirective,
    ParentValidatorDirective,
    ClassByAuthorityDirective,
    VisibilityByDeviceDirective,
    PriorityClassDirective,
    ScheduledClassDirective,
    StatusClassDirective,
    BtnDarkClassDirective,
    SchoolYearDisabledActionDirective,
    FeatureFlagHiddenDirective,
    TooltipDirective,
    TablistA11yDirective,
    AccordionA11yDirective,
    NgSelectA11yDirective,
    CollapseInertA11yDirective,
    DropdownToggleHaspopupA11yDirective,
    TimepickerMeridianA11yDirective,
    BsDatepickerKeyboardA11yDirective
  ],
  exports: [
    HasAnyAuthorityDirective,
    DelayRenderingDirective,
    DelayShowingDirective,
    AutocompleteOffDirective,
    ParentValidatorDirective,
    ClassByAuthorityDirective,
    VisibilityByDeviceDirective,
    PriorityClassDirective,
    ScheduledClassDirective,
    StatusClassDirective,
    BtnDarkClassDirective,
    SchoolYearDisabledActionDirective,
    FeatureFlagHiddenDirective,
    TooltipDirective,
    TablistA11yDirective,
    AccordionA11yDirective,
    NgSelectA11yDirective,
    CollapseInertA11yDirective,
    DropdownToggleHaspopupA11yDirective,
    TimepickerMeridianA11yDirective,
    BsDatepickerKeyboardA11yDirective
  ]
})
export class DirectivesModule {}
